/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Describe writable team fields without read-only response fields in the API client.
 * @export
 * @interface PatchedTeamWrite
 */
export interface PatchedTeamWrite {
    /**
     *
     * @type {string}
     * @memberof PatchedTeamWrite
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof PatchedTeamWrite
     */
    slug?: string;
}

/**
 * Check if a given object implements the PatchedTeamWrite interface.
 */
export function instanceOfPatchedTeamWrite(value: object): value is PatchedTeamWrite {
    return true;
}

export function PatchedTeamWriteFromJSON(json: any): PatchedTeamWrite {
    return PatchedTeamWriteFromJSONTyped(json, false);
}

export function PatchedTeamWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedTeamWrite {
    if (json == null) {
        return json;
    }
    return {

        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
    };
}

  export function PatchedTeamWriteToJSON(json: any): PatchedTeamWrite {
      return PatchedTeamWriteToJSONTyped(json, false);
  }

  export function PatchedTeamWriteToJSONTyped(value?: PatchedTeamWrite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'name': value['name'],
        'slug': value['slug'],
    };
}
